import React from "react";
import { useTranslation } from "react-i18next";
import { useCookieContext } from "../../context/CookieContext";

interface ConsentAwareEmbedProps {
  type: "youtube" | "google-maps" | "analytics" | "marketing";
  children: React.ReactNode;
  placeholder?: React.ReactNode;
}

const ConsentAwareEmbed: React.FC<ConsentAwareEmbedProps> = ({
  type,
  children,
  placeholder,
}) => {
  const { t } = useTranslation("common");
  const { cookieSettings, openBanner } = useCookieContext();

  const isAllowed = () => {
    switch (type) {
      case "youtube":
      case "google-maps":
      case "marketing":
        return cookieSettings.marketing;
      case "analytics":
        return cookieSettings.analytics;
      default:
        return false;
    }
  };

  if (!isAllowed()) {
    return (
      placeholder || (
        <div className="consent-placeholder">
          <p>
            {t("consent.blockMessage", {
              type: t(`consent.types.${type}`),
            })}
          </p>
          <button className="consent-placeholder__button" onClick={openBanner}>
            {t("consent.openSettings")}
          </button>
        </div>
      )
    );
  }

  return <>{children}</>;
};

export default ConsentAwareEmbed;
